import React, { useRef, useEffect } from "react";
import getAvatarUrl from "../../../../utils/get-avatar-url";

export const OrganizationCoachesSectionComponent = ({
  onToggleModal,
  onSelectOrganizationCoach,
  isFrom = "profile",
  users,
  activeUser,
  setOffsetHeight,
  showModal,
}) => {
  const activeUserId = activeUser._id;
  const divRef = useRef(null);
  /**
   * Order the list by name (descending) and also the first option would be the active user
   * @param {*} a
   * @param {*} b
   * @returns
   */
  function sortElements(array) {
    // get current user objet
    const currentUser = array.find((item) => item._id === activeUserId);

    // sort the rest by descending name
    const others = array
      .filter((item) => item._id !== activeUserId)
      .sort((a, b) => b.name.localeCompare(a.name));

    // add the current user to the beginning of the array. The viewer is not
    // always in the list — a Team Coach is filtered out of every "assign a
    // coach" picker, since they never hold assigned clients — and pinning
    // an absent one would put an undefined entry in the list and crash on
    // render (mirrors ChooseCoach.js's own sortElements fix).
    return currentUser ? [currentUser, ...others] : others;
  }

  const usersToRender = sortElements(users);

  /**
   * Listener to close the modal if the user clicks outside the div
   */
  useEffect(() => {
    // Function to handle clicks anywhere on the document
    function handleClickOutside(event) {
      if (divRef.current && !divRef.current.contains(event.target)) {
        // The click occurred outside the div
        onToggleModal();
        // You can perform additional actions here, such as closing a modal or resetting state.
      }
    }

    // Add the click listener to the document
    document.addEventListener("click", handleClickOutside);

    if (setOffsetHeight) {
      const space = divRef?.current
        ? window.innerHeight -
          (divRef?.current.offsetTop + divRef?.current.offsetHeight)
        : null;
      setOffsetHeight(space);
      space < 0 && window.scrollBy({ top: -space, behavior: "smooth" });
    }

    return () => {
      // Remove the click listener when the component unmounts
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <ul
      // ref={divRef}
      // style={isFrom === "list" ? { top: "65px" } : {}}
      // className={
      //   isFrom === "profile"
      //     ? "coach-section-invite-content coach-section-invite-content-position"
      //     : isFrom === "overview"
      //     ? "select-coach-organization-overview-athlete select-coach-organization-profile-athlete"
      //     : "select-coach-organization-profile-athlete"
      // }
      className={showModal ? "opened" : ""}
    >
      {usersToRender.map((item, idx) => {
        const { _id, name } = item;

        return (
          <li
            className="hover-subtitle-convert-organization"
            key={_id}
            onClick={(e) => {
              onToggleModal();
              onSelectOrganizationCoach(e, item);
            }}
          >
            <img
              src={getAvatarUrl(item)}
              alt="avatar"
              className="avatar-pick-organization-coach"
            />
            <span className="subtitle-organization-coaches-section">
              {name}
            </span>
            {/* {idx !== usersToRender.length - 1 && (
              <hr className="separator-coach-organization-section" />
            )} */}
          </li>
        );
      })}
    </ul>
  );
};
